import { useEffect } from 'react';

/**
 * Добавляет класс к body когда условие true
 * Используется для скрытия BottomNav когда открыта модалка с клавиатурой
 */
export function useBodyClass(className: string, condition: boolean) {
  useEffect(() => {
    if (condition) {
      document.body.classList.add(className);
    } else {
      document.body.classList.remove(className);
    }
    
    return () => {
      document.body.classList.remove(className);
    };
  }, [className, condition]);
}
